document.addEventListener("DOMContentLoaded", function () {
  const url = window.location.href;

  if (url.includes("car-seat-cover-transition-wrap") && url.includes("view=landing-page-ghl")) {
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener("click", function (e) {
        e.preventDefault();
        const targetId = this.getAttribute("href");
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          window.scrollTo({ top: targetElement.offsetTop, behavior: "smooth" });
        }
      });
    });
  }

  /* ------------------------------------------------------------------
   * REMOVED 26 Aug 2026 — JavaScript-injected free-shipping banner.
   *
   * This block injected a second announcement bar reading
   * "Free shipping on orders over $75 - no code needed!" while the
   * theme's own announcement-bar section said "...with code FREESHIP75",
   * which is wrong: US free shipping at $75+ is automatic, no code.
   *
   * The announcement-bar section is now the single source of truth.
   * BEFORE PUBLISHING, confirm its message reads:
   *   "Free US shipping on orders over $75 - no code needed."
   * Theme editor -> Sections -> Announcement bar.
   * ------------------------------------------------------------------ */
});

/* --------------------------------------------------------------------
 * Cart kit upsell — button handlers for snippets/om-kit-upsell.liquid
 * Added 26 Aug 2026 (Claude), for Josh.
 *
 * WHY THESE LIVE HERE AND NOT IN THE SNIPPET:
 * <cart-form> replaces its own innerHTML every time the cart changes.
 * A <script> tag inserted via innerHTML is never executed by the
 * browser, so the snippet's original inline script bound its listeners
 * once on first paint and went dead the moment the drawer re-rendered —
 * which is every single add-to-cart. That is why the buttons did
 * nothing. Delegated listeners on document survive every re-render.
 * Do not move this code back into the snippet.
 *
 * NO DISCOUNT CODES (Josh, 26 Aug 2026): adds go straight into the
 * cart at full price and the drawer refreshes in place. To restore the
 * 10% kit codes, put a data-om-code attribute back on the buttons and
 * redirect to '/discount/' + code + '?redirect=/cart' after the add.
 *
 * Every add is tagged _om_upsell = kit-drawer, matching the convention
 * the retired recommender used, so attach rate stays measurable from
 * order line items.
 * ------------------------------------------------------------------ */
(function () {
  var PREFIX = 'om_dismiss_';
  var busy = false;

  function getFlag(key) {
    try { return sessionStorage.getItem(PREFIX + key); } catch (e) { return null; }
  }

  function setFlag(key) {
    try { sessionStorage.setItem(PREFIX + key, '1'); } catch (e) {}
  }

  // Re-hide anything the shopper dismissed. Runs on load and again
  // after each cart re-render, because the fresh markup from the
  // server does not know about the dismissal.
  function applyDismissed() {
    var boxes = document.querySelectorAll('[data-om-upsell]');
    for (var i = 0; i < boxes.length; i++) {
      if (getFlag(boxes[i].getAttribute('data-om-upsell'))) {
        boxes[i].style.display = 'none';
      }
    }
  }

  function addToCart(items, btn) {
    if (busy) return;
    busy = true;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    for (var i = 0; i < items.length; i++) {
      items[i].properties = { '_om_upsell': 'kit-drawer' };
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'om_kit_upsell_add_to_cart', currency: 'USD' });
        } catch (e) { /* tracking must never break add-to-cart */ }
        // The theme's own refresh re-renders <cart-form>; the snippet
        // then re-evaluates and this box drops off on its own.
        if (typeof window.refreshCart === 'function') {
          window.refreshCart();
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Could not add — try again';
        setTimeout(function () { btn.textContent = label; }, 4000);
      })
      .finally(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || target.nodeType !== 1 || !target.closest) return;

    var dismiss = target.closest('[data-om-dismiss]');
    if (dismiss) {
      e.preventDefault();
      var key = dismiss.getAttribute('data-om-dismiss');
      var box = dismiss.closest('[data-om-upsell]');
      if (box) box.style.display = 'none';
      setFlag(key);
      return;
    }

    var single = target.closest('[data-om-add]');
    if (single) {
      e.preventDefault();
      var scope = single.closest('[data-om-upsell]') || document;
      var sel = scope.querySelector('[data-om-variant]');
      if (!sel || !sel.value) return;
      addToCart([{ id: Number(sel.value), quantity: 1 }], single);
      return;
    }

    var pair = target.closest('[data-om-add-pair]');
    if (pair) {
      e.preventDefault();
      addToCart(
        [
          { id: Number(pair.getAttribute('data-om-v1')), quantity: 1 },
          { id: Number(pair.getAttribute('data-om-v2')), quantity: 1 }
        ],
        pair
      );
    }
  });

  // Watch for the cart drawer re-rendering and re-apply dismissals.
  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.hasAttribute('data-om-cart-extras') ||
              (n.querySelector && n.querySelector('[data-om-cart-extras]'))) {
            applyDismissed();
            return;
          }
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyDismissed);
  } else {
    applyDismissed();
  }
})();
